import { SyncWizardAction, SyncWizardState } from "./syncWizard.types";

const INITIAL_STEP = 1;
const INITIAL_PAGE = 0;
const INITIAL_PROGRESS = 0;

export const initialSyncWizardState: SyncWizardState = {
  step: INITIAL_STEP,
  selectedItems: [],
  selectedWorkspace: null,
  targetBoard: null,
  targetGroup: null,
  processSubitems: true,
  processUpdates: true,
  confirmed: false,
  isSubmitting: false,
  submitErrorMessage: null,
  loadingProgress: INITIAL_PROGRESS,
  currentPage: INITIAL_PAGE,
  createdTargetItemIds: [],
  searchTerm: "",
  debouncedSearchTerm: "",
};

export const syncWizardReducer = (
  state: SyncWizardState,
  action: SyncWizardAction,
): SyncWizardState => {
  switch (action.type) {
    case "SET_STEP":
      return {
        ...state,
        step: action.payload,
      };

    case "GO_TO_PREVIOUS_STEP":
      return {
        ...state,
        step: state.step > 1 ? ((state.step - 1) as SyncWizardState["step"]) : state.step,
      };

    case "SET_SELECTED_ITEMS":
      return {
        ...state,
        selectedItems: action.payload,
      };

    case "SET_SELECTED_WORKSPACE":
      return {
        ...state,
        selectedWorkspace: action.payload,
      };

    case "SET_TARGET_BOARD":
      return {
        ...state,
        targetBoard: action.payload,
      };

    case "SET_TARGET_GROUP":
      return {
        ...state,
        targetGroup: action.payload,
      };

    case "SET_PROCESS_SUBITEMS":
      return {
        ...state,
        processSubitems: action.payload,
      };

    case "SET_PROCESS_UPDATES":
      return {
        ...state,
        processUpdates: action.payload,
      };

    case "SET_CONFIRMED":
      return {
        ...state,
        confirmed: action.payload,
      };

    case "SET_IS_SUBMITTING":
      return {
        ...state,
        isSubmitting: action.payload,
      };

    case "SET_SUBMIT_ERROR_MESSAGE":
      return {
        ...state,
        submitErrorMessage: action.payload,
      };

    case "SET_LOADING_PROGRESS":
      return {
        ...state,
        loadingProgress: action.payload,
      };

    case "SET_CURRENT_PAGE":
      return {
        ...state,
        currentPage: action.payload,
      };

    case "SET_CREATED_TARGET_ITEM_IDS":
      return {
        ...state,
        createdTargetItemIds: action.payload,
      };

    case "RESET_CREATED_TARGET_ITEM_IDS":
      return {
        ...state,
        createdTargetItemIds: [],
      };

    case "SET_SEARCH_TERM":
      return {
        ...state,
        searchTerm: action.payload,
      };

    case "SET_DEBOUNCED_SEARCH_TERM":
      return {
        ...state,
        debouncedSearchTerm: action.payload,
      };

    default:
      return state;
  }
};

